<template>
  <div class="forgot">
    <router-link to="/login">
      <div class="back">
        <img src='../assets/images/back@2x.png' alt=""/>
      </div>
    </router-link>
    <div class="title">Forgot Password</div>
    <div class="input">
      <div class="input-vp">
        <i class="icon"></i>
        <input type="text" class="email input-view" placeholder="Enter your Email" v-model="email" @keydown.enter.prevent="forgotClick"/>
      </div>
    </div>
    <div class="btn btn_forgot" @click="forgotClick">Next</div>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  import { Message } from 'element-ui'
  export default {
    data () {
      return {
        email: ''
      }
    },
    methods: {
      forgotClick () {
        this.$emit('show')
        axios.post('/proxy-api/client/user/index/reset-password', qs.stringify({
          email: this.email
        }))
        .then((result) => {
          console.log(result)
          if (result.data.status === '0') {
            this.$emit('hide')
            setTimeout(() => {
              location.href = './'
            }, 1000)
            Message({
              message: 'Please check your email.',
              type: 'success'
            })
          } else {
            this.$emit('hide')
            Message({
              message: result.data.msg,
              type: 'error'
            })
          }
        })
        .catch((error) => {
          console.log(error)
          this.$emit('hide')
          Message({
            message: 'Warning!',
            type: 'warning'
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  
</style>



// WEBPACK FOOTER //
// Forgot.vue?4bea27d1